<template>
  <div id="printerGroups">

    <TipBox info>
      <div v-html="$t('printer_groups.tip_content')"></div>
    </TipBox>

    <PageTitle :title="$t('printer_groups.title')" :subtitle="$t('printer_groups.subtitle')"></PageTitle>

    <Datatable
        entity="printerGroup"
        ref="datatable" v-if="inventory"
        :parameters="{inventory: inventory.id, company: company}"
        :onRowClick="onRowClick"
        :globalActions="[{text: 'printer_groups.new', method: onCreate}]"
        :rowActions="[
        {text: 'datatable.edit', method: onRowClick},
        {text: 'delete', method: onDelete}
      ]"
    />

    <Modal
        name="delete-confirmation"
        :title="$t('categories.confirmation')"
        dismissable
        :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteAction, primary: true}]">
      <p>{{$t('printer_groups.delete_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

  </div>
</template>

<script>
  import PageTitle from "@/components/PageTitle";
  import Datatable from "@/components/Datatable";
  import {Core} from "../../core/Core";

  export default {

    name: "PrinterGroups",

    components: { PageTitle, Datatable },

    data() {
      return {
        inventory: null,
        actionRow: {}
      }
    },

    computed: {
      company() {
        return this.$route.query.company || undefined;
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      this.$store.state.pageTitleTranslationKey = "printer_groups.title";
      this.$store.state.pageIcon = "/icon/printer.svg";
    },

    methods: {
      onCreate() {
        this.$router.push(this.$router.buildContext("/printer-group/new"));
      },

      onRowClick(row) {
        this.$router.push(this.$router.buildContext("/printer-group/edit", {id: row.id}));
      },

      onDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },

      async deleteAction() {
        showSpinner();
        let response = await Core.request('DELETE', `/api/printer_groups/${this.actionRow.id}?company=${this.company}`);
        hideSpinner();
        if (response) {
          this.$modal.show("delete-confirmation", false);
          this.$refs.datatable.query();
        } else {
          this.$modal.show("delete-confirmation", false);
          toast(this.$t("error.no_server"),"error");
        }
        hideSpinner();
      }
    }
  }
</script>

<style lang="scss" scoped>
  #printerGroups {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .page-container {
    display: flex;
    overflow: hidden;
  }
  .inventory-search {
    width: 280px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    label {
      margin-bottom: 10px;
    }
  }
  .groups {
    flex-grow: 1;
    overflow-x: auto;
  }
  .inventory-search__box {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 10px;
    overflow-y: auto;
    flex-grow: 1;
  }
</style>

<style lang="scss">
  #printerGroups {
    .page-title-2, .page-container, .page-footer, .datatable {
      max-width: 100%;
    }
  }
</style>
